import { render, staticRenderFns } from "./markdown-it-vue.vue?vue&type=template&id=a9d2120a"
import script from "./markdown-it-vue.vue?vue&type=script&lang=js"
export * from "./markdown-it-vue.vue?vue&type=script&lang=js"
import style0 from "./markdown-it-vue.vue?vue&type=style&index=0&id=a9d2120a&prod&lange=scss&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports